import { EnumValue } from "../interfaces/enumValue";
import Badge from './badge';

export class TopicBadge extends Badge {
    constructor(title: string, icon: string);
    constructor(activityType: EnumValue);

    constructor(titleOrActivityType: string | EnumValue, icon?: string) {
        if (typeof titleOrActivityType === 'string')
            super(titleOrActivityType, icon ?? '');
        else
            super(titleOrActivityType.text, titleOrActivityType.icon ?? '');
    }
}